import { type ListMetadata } from "utilities/list/list.types";

import {
    type AccountSwitcherItem,
    type JobPickerJob,
} from "commonComponents/utilities/JobPicker/JobPicker.api.types";
import {
    JobIdTypes,
    type JobPickerDisplayModes,
} from "commonComponents/utilities/JobPicker/JobPicker.types";

export const ALL_JOBS = Number(JobIdTypes.AllJobs);
export const GLOBAL_JOB = Number(JobIdTypes.GlobalJob);
export const GLOBAL_DOCS = Number(JobIdTypes.GlobalDocs);

export interface IJobsListCoreProps {
    selectedJobIds: number[] | number | null;
    displayMode: JobPickerDisplayModes;
    isTemplateMode: boolean;
    onJobPickerJobChanged: (job: JobPickerJob, keywordSearch: string) => Promise<void>;
    availableAccounts: AccountSwitcherItem[];
    keywordSearch: string;
    draftJobIds: number[];
    showAccountingOnTimeClock: boolean;
}

export interface IJobPickerJobsListProps extends IJobsListCoreProps {
    jobsListAndCount: { count: number; jobs: JobPickerJob[] } | null;
    loading: boolean;
    templatesOnly: boolean;
    isConnectedToAccounting: boolean;
    /** Full list of jobs before filtering, used to drive empty-state messaging. */
    jobs: JobPickerJob[];
    listMetadata: ListMetadata;
    clearKeywordSearch: () => void;
    onShowMoreThanOneHundred: () => void;
}

export interface IJobsListVirtualScrollProps extends IJobsListCoreProps {
    jobsListAndCount: { count: number; jobs: JobPickerJob[] };
    hasMoreJobs: boolean;
    onShowMoreThanOneHundred: () => void;
}

export interface IJobListItemProps extends IJobsListCoreProps {
    currentJob: JobPickerJob;
}

export interface IJobIconProps {
    currentJob: JobPickerJob;
    displayMode: JobPickerDisplayModes;
    showAccountingOnTimeClock: boolean;
    draftJobIds: number[];
}

/** Context passed to Virtuoso. Includes selectedJobIds so a selection change re-renders visible rows. */
export interface IVirtualScrollContext {
    hasMoreJobs: boolean;
    onShowMoreThanOneHundred: () => void;
    selectedJobIds: number[] | number | null;
    count?: number;
}
